import readingTime from '@utils/functions/readingTime';
import { AiOutlineEye } from 'react-icons/ai';
import { IoMdHourglass } from 'react-icons/io';
import Image from 'next/image';

const ViewsAndReadTime = ({ text, tutorialCard = false, views = null }) => {
  return (
    <div className="flex items-center text-sm">
      <div className="flex gap-5 text-gray-1">
        {!tutorialCard && (
          <p className="flex items-center gap-1 font-satoshi-medium text-[0.9rem] md:text-sm">
            <Image src="/assets/bytes/hourGlass.svg" width={13} height={13} alt="people" />
            {readingTime(text)} mins
          </p>
        )}
        <p className="flex items-center gap-1 font-satoshi-medium text-[0.9rem] md:text-sm">
          <Image src="/assets/bytes/people.svg" width={18} height={18} alt="people" />
          {views ?? Math.floor(Math.random() * 200) + 1000}
        </p>
      </div>
    </div>
  );
};

export default ViewsAndReadTime;
